import { AI_BUILDER_PROGRAM } from "@/data/aiBuilderPlaybook";
import { S2PElevateDeck } from "@/pages/S2PElevateAI";

const S2PAIBuilderPlaybook = () => (
  <S2PElevateDeck
    program={AI_BUILDER_PROGRAM}
    config={{
      storageNamespace: "ai-builder-playbook-v1",
      analyticsVariant: "s2p-ai-builder",
      seoTitle: "The AI Builder Playbook | Serve2Perform ELEVATE",
      seoDescription: "A 90-minute Serve2Perform ELEVATE training that turns a Job Brief into a bounded, tested, reviewable prototype with a clear human handoff.",
      seoKeywords: [
        "Serve2Perform",
        "ELEVATE",
        "AI Builder Playbook",
        "AI prototyping",
        "meta prompting",
        "vibe coding",
        "AI engineering for leaders",
      ],
      coverEyebrow: "Serve2Perform ELEVATE · The AI Builder Playbook",
      coverTitle: "The AI Builder Playbook",
      coverAudience: "From Job Brief to Verified Prototype",
      contentsEyebrow: "Serve2Perform ELEVATE · Build with evidence",
      contentsTitle: "Five modules",
      sessionNoun: "Module",
      finishEyebrow: "AI Builder Playbook complete",
      brandHref: "/s2p-elevate-ai",
      brandLinkLabel: "Return to Serve2Perform ELEVATE",
      exitHref: "/s2p-elevate-ai",
      exitLabel: "Back to ELEVATE",
      finishCtaHref: "/s2p-elevate-ai",
      finishCtaLabel: "Return to ELEVATE",
      guideHref: null,
    }}
  />
);

export default S2PAIBuilderPlaybook;
